import { useMemo } from 'react';
import { renderContentFromMetadata } from '@jutro/uiconfig';
import metadata from './SgEndorsementPolicies.metadata.json5';
import SgEndorsementPolicyTile from './sg-endorsement-policy-tile/SgEndorsementPolicyTile';
import './SgEndorsementPolicies.messages';

function SgEndorsementPolicies(props) {
    const {
        policies,
        setPolicyNumber
    } = props;

    const generateOverrides = useMemo(() => {
        const overrides = policies.map((item, index) => {
            return {
                [`sgSmallPolicyTile${index}`]: {
                    policy: item,
                    setPolicyNumber: setPolicyNumber
                }
            };
        });
        return Object.assign({}, ...overrides);
    }, [policies, setPolicyNumber]);

    const overrides = {
        sgEndorsementPoliciesTiles: {
            data: policies,
        },
        ...generateOverrides
    };
    const resolvers = {
        resolveComponentMap: {
            SgEndorsementPolicyTile: SgEndorsementPolicyTile
        }
    };

    return renderContentFromMetadata(metadata.componentContent, overrides, resolvers);
}

export default SgEndorsementPolicies;
